import { cast, types } from 'mobx-state-tree';
import { IOrder } from '../../main/entities';
import { mg } from '../../mg/mg';

export const OrderResultDialogStore = types
	.model('OrderResultDialog', {
		isOpen: false,
		orders: types.array(types.frozen<IOrder>()),
		errors: types.array(types.string),
		supplier: types.optional(types.frozen(), {}),
	})
	.views(self => ({
		get running() {
			return self.errors.length===1 && self.errors[0]==='running';
		},
	}))
	.views(self => ({
		get status() {
			if (self.running) return 'running';
			if (!self.orders.length) return 'impossible';
			return 'success';
		},
	}))
	.actions(self => ({
		close() {
			self.isOpen = false;
			self.orders = cast([]);
			self.errors = cast([]);
			self.supplier = {};
		},
	}))
	.actions(self => ({
		showSuccess(orders, supplier) {
			self.isOpen = true;
			self.orders = orders;
			self.errors = cast([]);
			self.supplier = mg.freezeIfDevelopment(supplier);
		},
		showFailure(errors) {
			console.log(errors);
			self.isOpen = true;
			self.orders = cast([]);
			self.errors = errors;
		},
	}));

export const orderResultDialogStore = OrderResultDialogStore.create({});
